import type { Mission } from '../missions.ts'

export const rd: Mission = {
  id: "rd",
  name: "USDA Rural Development",
  short: "RD",
  call: "Rural America",
  kind: "subagency",
  parent: "usda",
  url: "https://www.rd.usda.gov/",
  palette: {
    primary: "#005f92",
    secondary: "#16254c",
    accent: "#00674d",
  },
  colorSource: {
    kind: "site",
    url: "https://www.rd.usda.gov/",
  },
  motif: "house",
  mission: {
    text: "We are committed to helping improve the economy and quality of life in rural America.",
    url: "https://www.rd.usda.gov/about-rd",
  },
  fact: {
    text: "Rural Development's Rural Housing Service offers loans, grants, and loan guarantees for single and multi-family housing and essential community facilities in rural areas.",
    url: "https://www.rd.usda.gov/about-rd/agencies/rural-housing-service",
  },
  logo: {
    file: "public/logos/rd.svg",
    source: "https://commons.wikimedia.org/wiki/File:USDA-RuralDevelopment-Logo.svg",
  },
  identifier: {
    about: "https://www.rd.usda.gov/about-rd",
    accessibility: "https://www.rd.usda.gov/related-links/accessibility-statement",
    foia: "https://www.rd.usda.gov/contact-us/freedom-information-act-foia",
    noFear: "https://www.usda.gov/about-usda/working-usda/employee-services/usda-no-fear-act-report-information",
    oig: "https://www.oig.usda.gov/",
    performance: "https://www.usda.gov/about-usda/general-information/our-performance",
    privacy: "https://www.rd.usda.gov/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/rd-power-lines.jpg",
        small: "/media/rd-power-lines-sm.jpg",
        alt: "A steel transmission tower carries high voltage lines across golden grassy hills dotted with dark green oaks and a few grazing cattle.",
        title: "Transmission lines across rangeland in Contra Costa County, California, July 24, 2015",
        creator: "Lance Cheung, U.S. Department of Agriculture",
        source: "https://commons.wikimedia.org/wiki/File:USDA_Rural_Development_(RD)_Rural_Utilities_Service_(RUS)_Electric_Program_provides_leadership_and_capital_to_maintain,_expand,_upgrade,_and_modernize_America%27s_vast_rural_electric_infrastructure_-_44.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/rd-line-crew.jpg",
        small: "/media/rd-line-crew-sm.jpg",
        alt: "A utility bucket truck extends its boom to the crossarm of a tall wooden transmission pole beside a tree in a rural field.",
        title: "East Kentucky Power Cooperative installs rural transmission lines, April 7, 2026",
        creator: "U.S. Department of Agriculture",
        source: "https://commons.wikimedia.org/wiki/File:Rural_Electrification_Act_--_East_Kentucky_Power_Cooperative_(20260407-USDA-RD-KY-GT-0147).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
